import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import LoadingPage from 'src/pages/Loading';
const RoleBasedRoute = ({
  children,
  user,
  roles,
  include = true,
  external = false,
  exclude,
  redirectPath = '/'
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const theme = useTheme();
  if (exclude) {
    include = false;
  }
  useEffect(() => {
    // Set a timeout to navigate to the redirectPath if the user is not defined within 5 seconds
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
      // console.log('timeout');
      if (!user) {
        navigate(redirectPath, { replace: true });
      }
    }, 5000);

    // If the user is defined before the timeout, cancel the navigation
    if (user.role !== null) {
      setIsLoading(false);
      clearTimeout(timeoutId);
    }
    // Clean up the timeout when the component unmounts
    return () => clearTimeout(timeoutId);
  }, [user, history, redirectPath, theme]);

  // If user is still loading (i.e., user is not yet defined or 5 seconds have not passed),
  // you can show a loading message or a spinner here
  if (isLoading) {
    return <LoadingPage loading={isLoading} />;
  } else if (
    (user && include && !roles.includes(user?.role)) ||
    (user && exclude && roles.includes(user?.role)) ||
    external
  ) {
    return <Navigate to={redirectPath} replace />;
  }
  return children;
};

export default RoleBasedRoute;
